import type { IThirdPartyAuthFailReasons } from '@nerdwallet/js-auth-tools/registration';
import type { ActiveRegStatusNotificationActionType } from './constants';
import type { ReduxStore } from './types';

export const SET_GLOBAL_NAV_STATE = 'SET_GLOBAL_NAV_STATE';
export const SET_PRIVATE_GLOBAL_NAV_STATE = 'SET_PRIVATE_GLOBAL_NAV_STATE';
export const WINDOW_RESIZE = 'WINDOW_RESIZE';

type SetGlobalNavStateAction = ReduxStore & {
  type: typeof SET_GLOBAL_NAV_STATE;
};

type SetPrivateGlobalNavStateAction = ReduxStore & {
  type: typeof SET_PRIVATE_GLOBAL_NAV_STATE;
};

type WindowResize = {
  type: typeof WINDOW_RESIZE;
  width: number;
  height: number;
};

export type ActiveRegStatusNotificationAction = {
  type: ActiveRegStatusNotificationActionType;
  reason?: IThirdPartyAuthFailReasons;
  analytics: {
    // eslint-disable-next-line camelcase
    trk_location: string;
    // eslint-disable-next-line camelcase
    trk_format: string;
  };
};

export type ReduxAction =
  | SetGlobalNavStateAction
  | SetPrivateGlobalNavStateAction
  | WindowResize
  | ActiveRegStatusNotificationAction;

export const isSetNavStateAction = (
  action: ReduxAction
): action is SetGlobalNavStateAction | SetPrivateGlobalNavStateAction =>
  [SET_GLOBAL_NAV_STATE, SET_PRIVATE_GLOBAL_NAV_STATE].indexOf(action.type) !==
  -1;
